<template>
    <div class="basic_wrap mt44">
        
        <baseHeader :title="$t('setpwd.modifyLoginPassword')"></baseHeader>
        
        <div class="wrap">
            <div class="title">
                <p>{{ $t("setpwd.setNewLoginPassword") }}</p>
                <div class="cut" v-if="!codeStatus" @click="cutType(1)">
                    {{ $t("setpwd.usemobilenumber") }}
                </div>
            </div>
            
            <p class="bd_tel" v-if="codeStatus">
                {{ $t("setpwd.boundmobilenumber") }} +{{ ycmobile }}
            </p>
            
            <div class="inp_box" v-if="codeStatus">
                <div class="inp">
                    <input
                        type="number"
                        v-model="code"
                        :placeholder="$t('setpwd.SMSverificationcode')"
                    />
                </div>
                <van-count-down :time="time" class="btn getcode" @finish="timeCall">
          <span @click="sendcode">{{
                  showTime > 0 ? showTime : $t("setpwd.sendcode")
              }}</span>
                </van-count-down>
            </div>
            
            <div class="write_box" v-if="!codeStatus">
                <input
                    :type="passwordInp"
                    v-model="password"
                    :placeholder="$t('setpwd.originalloginpassword')"
                />
                <div
                    class="eye_bi"
                    @click="showPwd"
                    :class="passwordInp == 'text' ? 'eye' : ''"
                ></div>
            </div>
            <div class="write_new_pwd">
                <div class="write_box">
                    <input
                        :type="newpasswordInp"
                        v-model="npassword"
                        :placeholder="$t('setpwd.newpassword')"
                    />
                    <div
                        class="eye_bi"
                        @click="showNewsPwd"
                        :class="newpasswordInp == 'text' ? 'eye' : ''"
                    ></div>
                </div>
                <div class="write_box">
                    <input
                        :type="newpasswordInp"
                        v-model="rpassword"
                        :placeholder="$t('setpwd.confirmnewpassword')"
                    />
                    <div
                        class="eye_bi"
                        @click="showNewsPwd"
                        :class="newpasswordInp == 'text' ? 'eye' : ''"
                    ></div>
                </div>
            </div>
        </div>
        <div
            v-if="codeStatus"
            class="basic_btn"
            :class="
        rpassword != '' && code != '' && npassword != '' ? '' : 'no_touch'
      "
            @click="dxRevise"
        >
            {{ $t("setpwd.modify") }}
        </div>
        <div
            v-if="!codeStatus"
            class="basic_btn"
            :class="
        password != '' && rpassword != '' && npassword != '' ? '' : 'no_touch'
      "
            @click="oldRevise"
        >
            {{ $t("setpwd.modify") }}
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import {CountDown} from "vant";
import Fetch from "../../utils/fetch";
import baseHeader from "@/components/baseHeader";

Vue.use(CountDown);

export default {
    name: "setpwd",
    data() {
        return {
            showTime: 0,
            timeId: null,
            time: 0,
            password: "",
            rpassword: "",
            npassword: "",
            mobile: "",
            ycmobile: "",
            passwordInp: "password",
            newpasswordInp: "password",
            codeStatus: true,
            codeOK: false,
            code: "",
            is_send: false,
        };
    },
    components: {
        baseHeader
    },
    created() {
        this.$parent.footer("user", false);
    },
    mounted() {
        Fetch("/user/info").then((r) => {
            this.mobile = r.data.mobile;
            this.ycmobile = r.data.mobile.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
        });
        
        Fetch("/sms/getRecentCode", {}).then((res) => {
            console.log(res);
            if (res.data) {
                this.is_send = true;
                let leftTime = 600 - (Date.parse(new Date()) / 1000 - res.data.time);
                console.log(Date.parse(new Date()) / 1000, res.data.time);
                console.log(leftTime);
                this.time = leftTime * 1000;
                this.showTime = leftTime;
                this.timeId = setInterval(() => {
                    this.showTime--;
                }, 1000);
            }
        });
    },
    destroyed() {
        if (this.timeId) clearInterval(this.timeId);
    },
    methods: {
        cutType(n) {
            n == 1 ? (this.codeStatus = true) : (this.codeStatus = false);
            this.rpassword = "";
            this.npassword = "";
        },
        timeCall() {
            this.is_send = false;
            this.time = 0;
            clearInterval(this.timeId);
            console.log("coundown finished");
        },
        sendcode() {
            if (this.is_send) {
                return;
            }
            this.is_send = true;
            Fetch("/sms/sendCode", {
                mobile: this.mobile,
                type: 4,
            })
                .then(() => {
                    this.time = 600 * 1000;
                    this.showTime = 600;
                    this.timeId = setInterval(() => {
                        this.showTime--;
                    }, 1000);
                    this.$toast({
                        background: "#07c160",
                        message: this.$t("setpwd.sendsuccessfully"),
                    });
                })
                .catch(() => {
                    this.is_send = false;
                });
        },
        showPwd() {
            this.passwordInp == "password"
                ? (this.passwordInp = "text")
                : (this.passwordInp = "password");
        },
        showNewsPwd() {
            this.newpasswordInp == "password"
                ? (this.newpasswordInp = "text")
                : (this.newpasswordInp = "password");
        },
        dxRevise() {
            if (!this.npassword) {
                this.$toast(this.$t("setpwd.newpasswordcannotbeempty"));
                return false;
            }
            if (this.npassword.length < 6) {
                this.$toast("Password length must be greater than 6");
                return false;
            }
            if (this.npassword !== this.rpassword) {
                this.$toast(this.$t("setpwd.inconsistent"));
                return false;
            }
            
            Fetch("/user/repasswd", {
                password: this.npassword,
            }).then(() => {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("setpwd.modifiedsuccessfully"),
                });
                setTimeout(() => {
                    localStorage.removeItem("token");
                    this.$router.replace("/");
                }, 1000);
            });
        },
        oldRevise() {
            if (!this.password) {
                this.$toast(this.$t("setpwd.originalpasswordcannotbeempty"));
                return false;
            }
            
            if (this.password.length < 6) {
                this.$toast("Password length must be greater than 6");
                return false;
            }
            
            if (!this.npassword) {
                this.$toast(this.$t("setpwd.newpasswordcannotbeempty"));
                return false;
            }
            if (this.npassword !== this.rpassword) {
                this.$toast(this.$t("setpwd.inconsistent"));
                return false;
            }
            Fetch("/user/repasswd", {
                passwd: this.password,
                npasswd: this.npassword,
            }).then(() => {
                this.$toast({
                    background: "#07c160",
                    message: this.$t("setpwd.modifiedsuccessfully"),
                });
                this.$router.replace("/safe");
            });
        },
    },
};
</script>

<style lang="less" scoped>
.back_left {
    background: url(../../views/images/item/back_b.png) no-repeat center center;
}

.big_tit {
    color: #000000;
}

.no_touch {
    pointer-events: none;
}

.wrap {
    padding: 15px 20px 0 20px;
}

.title {
    width: 100%;
    height: 25px;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: white;
    p {
        font-size: 18px;
        color: white;
        font-weight: 400;
    }
    
    .cut {
        font-size: 12px;
        color: #3d96ff;
    }
}

.bd_tel {
    margin-top: 23px;
    color: white;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 23px;
}

.inp_box {
    display: flex;
    justify-content: space-between;
    height: 45px;
    margin-top: 9px;
    
    .inp {
        width: 195px;
        border: 1px solid rgba(0, 0, 0, 0.1);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;
        border-radius: 2px;
        background-color: #ffffff;
        
        input {
            width: 100%;
            height: 22px;
            line-height: 22px;
            font-size: 16px;
        }
    }
    
    .getcode {
        flex: 1;
        margin-left: 10px;
        font-size: 16px;
        text-align: center;
        line-height: 45px;
        //color: #ffffff;
        height: 45px;
        background: linear-gradient(#fbe4cb, #e7bb90);
        color: #512E20;
        font-weight: 700;
        border-radius: 8px;
    }
    
    .reset_code {
        background: rgba(228, 228, 228, 1);
        color: rgba(0, 0, 0, 0.3);
    }
}

.write_box {
    width: 100%;
    height: 45px;
    margin-top: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    border-radius: 2px;
    background-color: #ffffff;
    
    input {
        width: 100%;
        height: 22px;
        line-height: 22px;
        font-size: 16px;
    }
}

.eye_bi {
    width: 21px;
    height: 25px;
    background: url(../images/user/eye2.png) no-repeat center center;
    background-size: 100% auto;
    
    &.eye {
        background: url(../images/user/eye1.png) no-repeat center center;
        background-size: 100% auto;
    }
}

.basic_btn {
    background: linear-gradient(#fbe4cb, #e7bb90);
    color: #512E20;
    font-weight: 700;
    margin: 43px auto 0 auto;
}

.write_new_pwd {
    margin-top: 32px;
    
    .write_box:first-child {
        margin-bottom: 18px;
        margin-top: 0px;
    }
    
    .write_box:last-child {
        margin-top: 0px;
    }
}
</style>
